const mutations = {
  SET_COMMUNICATIONS_PAGINATION (state, data) {
    let paginationInfo = JSON.parse(JSON.stringify(data))
    if (paginationInfo.total_elements <= 30 ) {
      paginationInfo.total_pages = 1
    } else {
      paginationInfo.total_pages = Math.trunc(paginationInfo.total_elements/30)+1
    }
    state.pagination = {
      ...state.pagination,
      ...paginationInfo
    }
  },
  SET_COMMUNICATIONS_LIST (state, data) {
    state.items = JSON.parse(JSON.stringify(data))
  },
  SET_COMMUNICATION_TO_EDIT (state, data) {
    const communicationInfo = JSON.parse(JSON.stringify(data))
    state.communicationToEdit = {
      ...state.communicationToEdit,
      ...communicationInfo
    }
  },
  UNSET_COMMUNICATION_TO_EDIT (state, data) {
    state.communicationToEdit = {
      copy: {
        copy_id: null,
        copy_name: '',
        product: {
          product_id: null,
          product_name: '',
          product_is_active: null,
          product_updated_at: ''
        },
        copy_is_active: null,
        copy_updated_at: ''
      },
      communication_text: '',
      communication_text_normalized: '',
      communication_id_shot: '',
      communication_comment_shot: '',
      communication_type: '',
      communication_is_active: true,
      communication_is_formula_lancamento: true,
      communication_approval: true,
      communication_relationship: true,
      communication_updated_at: ''
    }
  },
  SET_PAGE (state, data) {
    state.page = data
  },
  SET_STATUS_FILTER (state, data) {
    state.is_active = data
  },
  SET_PRODUCT_FILTER (state, data) {
    state.product_id = data
  },
  SET_SEARCH_TEXT_FILTER (state, data) {
    state.search_text = data
  },
  SET_LOADING (state, data) {
    state.loading = data
  },
  SET_TAB_NEW_COMMUNICATION (state, data) {
    state.newCampaign = data
  }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/communication/mutations.js